// /opt/isp_erp/frontend/src/pages/admin/instalaciones/CargaMasiva.jsx
import React, { useState } from "react";
import axios from "../../../api/axios";
import { useNavigate } from "react-router-dom";
import "./CargaMasiva.css";

export default function CargaMasiva() {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [resultado, setResultado] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Validar extensión
      const extension = selectedFile.name.split('.').pop().toLowerCase();
      if (!['xlsx', 'xls', 'csv'].includes(extension)) {
        alert("Solo se permiten archivos Excel (.xlsx, .xls) o CSV (.csv)");
        e.target.value = '';
        return;
      }
      setFile(selectedFile);
      setResultado(null);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Seleccione un archivo");
      return;
    }

    setCargando(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post("/installations/carga-masiva", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      setResultado({
        tipo: "exito",
        ...res.data
      });

      // Limpiar el input file
      document.getElementById('file-input').value = '';
      setFile(null);

    } catch (error) {
      console.error("Error en carga masiva:", error);
      setResultado({
        tipo: "error",
        mensaje: error.response?.data?.detail || "Error al procesar el archivo",
        detalle: error.response?.data
      });
    } finally {
      setCargando(false);
    }
  };

  const descargarPlantilla = () => {
    // Crear contenido CSV de ejemplo
    const headers = [
      'tipo_identificacion',
      'identificacion',
      'nombres',
      'apellidos',
      'telefono',
      'email',
      'direccion',
      'ciudad',
      'servicio',
      'plan',
      'ficha',
      'vineta'
    ].join(',');

    const ejemplo = [
      'CEDULA,1234567890,JUAN,PEREZ,0999999999,juan@email.com,"Dirección ejemplo",Quito,INTERNET,"500 MEGAS","Ficha ejemplo","Viñeta ejemplo"'
    ].join('\n');

    const contenido = `${headers}\n${ejemplo}`;

    const blob = new Blob([contenido], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'plantilla_carga_masiva.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="carga-masiva-container">
      <div className="carga-masiva-wrapper">
        {/* Header con botón volver */}
        <div className="carga-header">
          <button
            onClick={() => navigate('/instalaciones')}
            className="btn-back"
            title="Volver a instalaciones"
          >
            ←
          </button>
          <div className="header-title">
            <h1>Carga Masiva de Clientes</h1>
            <p>Suba un archivo Excel o CSV para crear múltiples instalaciones en estado PENDIENTE</p>
          </div>
        </div>

        {/* Tarjeta principal */}
        <div className="carga-card">
          {/* Botón de plantilla */}
          <div className="plantilla-section">
            <button
              onClick={descargarPlantilla}
              className="btn-plantilla"
            >
              📥 Descargar plantilla de ejemplo
            </button>
          </div>

          {/* Área de subida */}
          <div className={`upload-area ${file ? 'has-file' : ''}`}>
            <input
              id="file-input"
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={handleFileChange}
              className="file-input"
            />

            <div className="upload-content">
              <div className="upload-icon-container">
                <span className="upload-icon">📤</span>
              </div>
              
              <p className="upload-filename">
                {file ? file.name : "Seleccione un archivo"}
              </p>
              
              <p className="upload-info">
                {file
                  ? `${(file.size / 1024).toFixed(2)} KB`
                  : "Excel o CSV - Máximo 10MB"}
              </p>

              {!file && (
                <label htmlFor="file-input" className="btn-browse">
                  Buscar archivo
                </label>
              )}

              {file && (
                <div className="upload-actions">
                  <label htmlFor="file-input" className="btn-change">
                    Cambiar archivo
                  </label>
                  <button
                    onClick={handleUpload}
                    disabled={cargando}
                    className="btn-upload"
                  >
                    {cargando ? (
                      <>
                        <span className="loading-spinner-small"></span>
                        Procesando...
                      </>
                    ) : (
                      <>
                        <span>📤</span>
                        Subir archivo
                      </>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Resultado */}
          {resultado && (
            <div className={`resultado-card resultado-${resultado.tipo}`}>
              <div className="resultado-header">
                {resultado.tipo === 'exito' ? (
                  <span className="resultado-icon">✅</span>
                ) : (
                  <span className="resultado-icon">❌</span>
                )}
                <h3 className={`resultado-title resultado-${resultado.tipo}-title`}>
                  {resultado.tipo === 'exito' ? 'Carga completada' : 'Error en la carga'}
                </h3>
              </div>

              {resultado.tipo === 'exito' ? (
                <div className="resultado-exito">
                  <div className="stats-grid">
                    <div className="stat-card total">
                      <span className="stat-label">Total procesadas</span>
                      <span className="stat-value">
                        {(resultado.exitosas || 0) + (resultado.fallidas || 0)}
                      </span>
                    </div>
                    <div className="stat-card exitosas">
                      <span className="stat-label">Exitosas</span>
                      <span className="stat-value">{resultado.exitosas || 0}</span>
                    </div>
                  </div>

                  {resultado.fallidas > 0 && (
                    <div className="fallidas-section">
                      <p className="fallidas-titulo">
                        Fallidas: {resultado.fallidas}
                      </p>
                      <ul className="fallidas-lista">
                        {resultado.detalle_fallidas?.map((error, i) => (
                          <li key={i}>{error}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <div className="resultado-actions">
                    <button
                      onClick={() => navigate('/instalaciones')}
                      className="btn-ver-instalaciones"
                    >
                      Ver instalaciones creadas →
                    </button>
                  </div>
                </div>
              ) : (
                <p className="resultado-error-mensaje">{resultado.mensaje}</p>
              )}
            </div>
          )}

          {/* Instrucciones */}
          <div className="instrucciones">
            <h4 className="instrucciones-titulo">📋 Formato del archivo:</h4>
            <ul className="instrucciones-lista">
              <li>
                <span className="badge obligatorio">Obligatorias</span>
                identificación, nombres, apellidos
              </li>
              <li>
                <span className="badge opcional">Opcionales</span>
                tipo_identificacion, teléfono, email, dirección, ciudad, servicio, plan, ficha, viñeta
              </li>
              <li>
                <span className="badge servicio">Servicios válidos</span>
                INTERNET, TV, DUOPACK (por defecto INTERNET)
              </li>
              <li>
                <span className="badge formato">Formato</span>
                Nombres y apellidos se convertirán automáticamente a mayúsculas
              </li>
              <li>
                <span className="badge validacion">Validación</span>
                Identificación no debe repetirse
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
